import moment from "moment";
import React, { useState } from "react";
import manualChange from "../../../controllers/booking/postTicketing/change/manualChange";
import { enqueueSnackbar } from "notistack";
import Button1 from "../../form/Button1";
import ManualPassengerForm from "./ManualPassengerForm";
import ManualFlightDetailForm from "./ManualFlightDetailForm";
import selectFlightChange from "../../../controllers/booking/postTicketing/change/selectFlightChange";
import { CompareFlightChange } from "./CompareFlightChange";

export default function ManualChange({
  data,
  callback,
  newSegment,
  setNewSegment,
  flights,
  close,
}) {
  const [loadings, setLoadings] = useState({ submit: false });

  const [onEdit, setOnEdit] = useState(true);

  // async function handleManual() {
  //     const payload = {
  //       "changeOrderId": data?._id,
  //       ...newSegment,
  //       "travelers": travelers || [
  //           // {
  //           //     "id": ""
  //           // }
  //       ],
  //     //   "pnr": newPNR || undefined
  //     }
  //     // if(data?.newSegment?.length) {
  //     //   payload.flights = data?.newSegment?.map(obj => (
  //     //     {
  //     //         "id": obj?._id,
  //     //         "departureDate": moment(`${obj?.departure?.date} ${obj?.departure?.time}`,'MMM DD YYYY hh:mm ')?.toString()
  //     //     }
  //     //   ))
  //     //   payload.destinations = data?.newSegment?.map(obj => (
  //     //     {
  //     //         "id": obj?._id,
  //     //         "departureDate": moment(`${obj?.departure?.date} ${obj?.departure?.time}`,'MMM DD YYYY hh:mm ')?.toString()
  //     //     }
  //     //   ))
  //     // }
  //     // if(data?.passengerInfo?.length) {
  //     //   payload.travelers = data?.passengerInfo?.map(({_id,...obj}) => obj)
  //     // }
  //     const newSegmentObject =  payload?.flights?.map(obj => ({
  //         ...obj,
  //         _id: undefined,
  //         stops: undefined,
  //         "aircraftCode": obj?.aircraftCode,
  //         "flightNumber": obj?.flightNumber,
  //         "departure": {
  //             "time": moment(obj?.departureTime,'hh:mm A').format("HH:mm"),
  //             "date": moment(obj?.departureDate).format('YYYY-MM-DD'),
  //             "location": obj?.departureLocation,
  //             "airport": obj?.departureAirport,
  //             "city": obj?.departureCity
  //         },
  //         "arrival": {
  //             "time": moment(obj?.arrivalTime,'hh:mm A').format("HH:mm"),
  //             "date": moment(obj?.arrivalDate).format('YYYY-MM-DD'),
  //             "location": obj?.arrivalLocation,
  //             "airport": obj?.arrivalAirport,
  //             "city": obj?.arrivalCity
  //         },
  //         "cabinClass": obj?.cabinClass,
  //         "bookingClass": obj?.bookingClass,
  //         segmentRef: obj?.segmentRef,
  //         airline: {
  //           "image": {
  //                 "url": obj?.airlineImage,
  //                 "description": obj?.airlineName,
  //             },
  //           "marketing": obj?.airline,
  //           "operating": obj?.airline
  //         },
  //         id: data?._id,
  //     }))

  //     setLoadings({...loadings,submit: true})
  //     const res = await selectFlightChange({reshopOffer: newSegmentObject});
  //     // const res = await manualChange(payload);
  //     setLoadings({...loadings,submit: false})
  //     if(res.return) {
  //       enqueueSnackbar('Update Succesfull.',{variant: 'success'})
  //       callback && callback()
  //     } else enqueueSnackbar(res.msg,{variant: 'error'})
  //   }

  console.log(data, newSegment, flights);

  return (
    <div className="flex flex-col ">
      {
        // <ManualPassengerForm {...{data:travelers,setData:setTravelers}} passengers={data?.passengerInfo} />
        data?.changeRequest === "Flight" ? (
          <div className="flex flex-col gap-4">
            <ManualFlightDetailForm
              {...{ data: newSegment, setData: setNewSegment }}
              dataObj={data}
              returnExpands={(expands) =>
                setOnEdit((expands || [])?.some((val) => val))
              }
              // updateComponent={
              //   <Button1 loading={loadings.submit} onClick={handleManual}>Update</Button1>
              // }
            />
          </div>
        ) : null
      }
      {/* <div>
            <h5>Are you sure you want to confirm this changes?</h5>
            <p>Please review the change request and confirm they are accurate.</p>
        </div> */}
      {data?.changeRequest === "Flight" && onEdit ? (
        <div className="flex gap-4">
          <div className="">
            {close ? (
              <Button1 onClickc={() => close()} variant="outlined">
                Cancel
              </Button1>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}
